'use strict';

var styled = require('styled-components');

function _interopDefaultCompat (e) { return e && typeof e === 'object' && 'default' in e ? e : { default: e }; }

var styled__default = /*#__PURE__*/_interopDefaultCompat(styled);

const containerClassName = 'paginator';
const pageLinkClassName = 'page';
const activeLinkClassName = 'active';
const breakClassName = 'break';
const previousLinkClassName = 'previousBtn';
const nextLinkClassName = 'nextBtn';
const disabledClassName = 'disabledBtn';
const paginatorArrowBtnCss = styled.css `
  display: inline-flex;
  height: 30px;
  width: 30px;
  justify-content: center;
  align-items: center;
  color: ${({ theme }) => theme.colors.body.text};
  margin-left: 10px;
  cursor: pointer;
  pointer-events: initial;
`;
const paginatorPageCss = styled.css `
  width: 30px;
  height: 30px;
  margin: 0 5px;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  color: ${({ theme }) => theme.colors.body.text};
  text-decoration: none;
  cursor: pointer;
  pointer-events: initial;
`;
const paginatorActiveCss = styled.css `
  color: white;
  background-color: ${({ theme }) => theme.colors.primary.normal};
`;
const paginatorHoverCss = styled.css `
  color: ${({ theme }) => theme.colors.primary.normal};
  border-radius: 50%;
  background-color: ${({ theme }) => theme.colors.primary.alpha};
`;
const PaginatorContainerStyled = styled__default.default.div `
  user-select: none;
  padding: 15px 0;

  .${containerClassName} {
    width: 100%;
    list-style: none;
    display: inline-flex;
    justify-content: flex-end;
    align-items: center;
    margin: auto;
    padding: 0;
  }

  .${pageLinkClassName} {
    ${paginatorPageCss}

    :hover {
      ${paginatorHoverCss}
    }
  }

  .${breakClassName} a {
    ${paginatorPageCss}
  }

  .${activeLinkClassName} {
    ${paginatorActiveCss}
    border-radius: 50%;

    :hover {
      ${paginatorActiveCss}
    }
  }

  .${nextLinkClassName} {
    ${paginatorArrowBtnCss}

    :hover {
      ${paginatorHoverCss}
    }
  }

  .${previousLinkClassName} {
    ${paginatorArrowBtnCss}
    margin-left: 0;
    margin-right: 10px;

    :hover {
      ${paginatorHoverCss}
    }
  }

  .${disabledClassName} a {
    cursor: default;
    color: ${({ theme }) => theme.colors.disabled.text};

    :hover {
      color: ${({ theme }) => theme.colors.disabled.text};
      border-radius: initial;
      background-color: inherit;
    }
  }
`;

exports.PaginatorContainerStyled = PaginatorContainerStyled;
exports.activeLinkClassName = activeLinkClassName;
exports.breakClassName = breakClassName;
exports.containerClassName = containerClassName;
exports.disabledClassName = disabledClassName;
exports.nextLinkClassName = nextLinkClassName;
exports.pageLinkClassName = pageLinkClassName;
exports.previousLinkClassName = previousLinkClassName;
//# sourceMappingURL=paginator.styles.js.map
